import React from 'react';
import { motion } from 'framer-motion';
const stackItems = [{
  title: "L'Ebook Maître : RÉCOLTE URBAINE",
  value: '47$',
  desc: 'Le protocole exact pour produire 15kg/mois sur 1m². Installation, lumière et nutriments.',
  img: 'https://cdn.magicpatterns.com/uploads/xmYHidf66EEvJK3rxLbFnP/COVER_EBOOK_PRINCIPAL.png',
  tag: 'LE CŒUR DU SYSTÈME'
}, {
  title: 'BONUS 1 : Calendrier de Semis Intégral 2026',
  value: '17$',
  desc: 'Québec & France. Ne devinez plus. Sachez exactement quoi planter ce mois-ci pour récolter le mois prochain.',
  img: 'https://cdn.magicpatterns.com/uploads/oVBBnxHWkhzYwBXKnVSiNq/COVER_BONUS_1.png',
  tag: 'INCLUS GRATUITEMENT'
}, {
  title: 'BONUS 2 : Guide "Sauvez 500$/an"',
  value: '37$',
  desc: 'La liste noire des 10 cultures les plus chères au supermarché que vous DEVEZ faire pousser vous-même.',
  img: 'https://cdn.magicpatterns.com/uploads/nyFyqN8niyVAXkaqmuEKr8/COVER_BONUS_2.png',
  tag: 'INCLUS GRATUITEMENT'
}];
export function ValueStack() {
  return <section className="bg-cream py-24 px-6" data-id="element-118">
      <div className="max-w-[1100px] mx-auto" data-id="element-119">
        <div className="text-center mb-16" data-id="element-120">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-121">
            Ce que vous obtenez aujourd'hui
          </h2>
          <div className="h-1 w-20 bg-accent mx-auto rounded-full" data-id="element-122"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-123">
          {stackItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col border border-cream-dark" data-id="element-124">
              <div className="relative h-48 md:h-56 bg-cream-dark overflow-hidden" data-id="element-125">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover" data-id="element-126" />
                <div className="absolute top-4 right-4 bg-forest text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-127">
                  {item.tag}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-128">
                <h3 className="font-serif text-xl font-bold text-charcoal mb-2" data-id="element-129">
                  {item.title}
                </h3>
                <p className="font-sans text-sm text-forest font-semibold mb-4" data-id="element-130">
                  Valeur:{' '}
                  <span className="line-through text-charcoal/40" data-id="element-131">
                    {item.value}
                  </span>
                </p>
                <p className="font-sans text-charcoal/70 text-sm leading-relaxed flex-grow" data-id="element-132">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-forest rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-133">
          {/* Decorative background */}
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-accent to-transparent" data-id="element-134"></div>

          <div className="relative z-10 flex flex-col items-center justify-center space-y-6" data-id="element-135">
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-12 w-full" data-id="element-136">
              <div className="text-center" data-id="element-137">
                <p className="font-sans text-cream/70 uppercase tracking-widest text-sm mb-1" data-id="element-138">
                  Valeur Totale
                </p>
                <p className="font-serif text-3xl md:text-4xl text-cream/50 line-through decoration-urgency decoration-4" data-id="element-139">
                  101$
                </p>
              </div>
              <div className="hidden md:block w-px h-16 bg-cream/20" data-id="element-140"></div>
              <div className="text-center" data-id="element-141">
                <p className="font-sans text-accent uppercase tracking-widest text-sm mb-1 font-bold" data-id="element-142">
                  Votre Prix Aujourd'hui
                </p>
                <p className="font-serif text-5xl md:text-7xl text-white font-bold" data-id="element-143">
                  9.97$
                </p>
              </div>
            </div>

            <p className="font-sans text-cream/80 italic text-lg" data-id="element-144">
              (Moins cher qu'une seule salade composée au restaurant)
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}